import React from 'react';
import { useParams } from 'react-router-dom';
import { useEvaluations } from 'containers/CarnetsDeNotes/queries/evaluations/useEvaluations';
import SpinnerComponent from 'components/Spinner/ScreenSpinner';
import SchoolyearRedirect from 'components/Redirect/SchoolyearRedirect';
import { carnetUrls } from 'containers/CarnetsDeNotes/urls';

export function RedirectToAnotherEvaluation() {
  const params = useParams<{
    carnetDeNotesId: string;
  }>();
  const carnetDeNotesId = params.carnetDeNotesId as string;
  const { data, isInitialLoading, isFetched } = useEvaluations(carnetDeNotesId);

  if (isInitialLoading || !isFetched || !data) {
    return <SpinnerComponent />;
  }
  if ((data || []).length === 0) {
    return <SchoolyearRedirect to={`${carnetUrls.details(carnetDeNotesId)}`} />;
  }

  return (
    <SchoolyearRedirect
      to={`${carnetUrls.evaluationDetail(carnetDeNotesId, data[0].id)}`}
    />
  );
}
